import { Layout, Select } from "antd";
import styled from "styled-components";

export const FastFilterWrapper = styled(Layout)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
    flex-direction: row;
    margin-top: -1px;

    .ant-select-selection-placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }

    .ant-select-dropdown {
        -webkit-overflow-scrolling: auto;
        overscroll-behavior: contain;
        scroll-behavior: auto;
    }

    .custom-select-container .ant-select-item-option {
        height: 48px !important;
        line-height: 48px !important;
        font-size: 18px !important;
        padding: 12px 16px !important;
    }
`;

export const StyledSelect = styled(Select)`
    .ant-select-item-option {
        height: 48px;
        line-height: 48px;
        font-size: 18px;
    }
`;
